import React from "react";
import PageWrapper from "../../components/NIISPageWrapper/PageWrapper";
import HeroSection from "../../components/NIISHeroSection/HeroSection";
import HeroCaption from "../../components/NIISHeroCaption/HeroCaption";
import AboutNibaResponsive from "../../components/NIISAboutNibaResponsive/AboutNibaResponsive";
import FromStudentsResponsive from "../../components/NIISFromStudentsResponsive/FromStudentsResponsive";
import InfographyResponsive from "../../components/NIISInfographyResponsive/InfographyResponsive";
import TrusteeResponsive from "../../components/NIISTrusteeResponsive/TrusteeResponsive";
import QualityPolicyContentResponsive from "../../components/NIISQualityPolicyContentResponsive/QualityPolicyContentResponsive";

const AboutUsPage = () => {
	return (
		<PageWrapper className="mt-n6">
			<HeroSection className="bg-page-background-4">
				<HeroCaption
					title="About NIIS"
					position="bottom-left"
					breadcrumb={true}
					breadcrumbPrefix="Home"
				/>
			</HeroSection>
			<AboutNibaResponsive />
			<TrusteeResponsive />
			{/* <InfographyResponsive />
			<FromStudentsResponsive />
			<QualityPolicyContentResponsive /> */}
		</PageWrapper>
	);
};

export default AboutUsPage;
